"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _FullScreenContext = _interopRequireDefault(require("./FullScreenContext"));
var _Icon = require("@gogame/ui/Icon");
var _IconButton = _interopRequireDefault(require("@gogame/ui/IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FullScreenToggler = /*#__PURE__*/(0, _react.forwardRef)(function (_, ref) {
  var _useContext = (0, _react.useContext)(_FullScreenContext["default"]),
    fullScreen = _useContext.fullScreen,
    toggle = _useContext.toggle;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
    onClick: toggle,
    icon: fullScreen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.FullscreenExitIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.FullscreenIcon, {}),
    tooltip: "".concat(fullScreen ? 'Disable' : 'Enable', " fullscreen grid"),
    // key to hide tooltip
    ref: ref
  }, "toggler-".concat(fullScreen ? 'fullscreen' : ''));
});
FullScreenToggler.displayName = 'FullScreenToggler';
var _default = exports["default"] = FullScreenToggler;